import React from 'react';
import { Link } from 'react-router-dom';
import { useScreenSize } from '../../utils/media-query';
import { Button } from 'devextreme-react/button';
import Toolbar, { Item } from 'devextreme-react/toolbar';
import DataGrid, { 
  Column, 
  Selection,
  FilterRow,
  Paging,
  Pager,
} from 'devextreme-react/data-grid';
import './style.scss';

export default function RightSidePanel(props) {
  const { isXSmall } = useScreenSize();
  const [openedSide, setOpenedSide] = React.useState(false);

  const dataTable = [
    { id: 1, name: "Duyệt ĐK tăng ca - Production", code: 'OT_AI05', modifyDate: "2021-12-27T00:00:00.000Z", modifier: "", dataType: "Over Time Registration", employee: ""},
    { id: 2, name: "Duyệt ĐK tăng ca - Production", code: 'OT_AI05', modifyDate: "2021-12-27T00:00:00.000Z", modifier: "", dataType: "Over Time Registration", employee: ""},
    { id: 3, name: "Duyệt ĐK tăng ca - Production", code: 'OT_AI05', modifyDate: "2021-12-27T00:00:00.000Z", modifier: "", dataType: "Over Time Registration", employee: ""},
    { id: 4, name: "Duyệt ĐK tăng ca - Production", code: 'OT_AI05', modifyDate: "2021-12-27T00:00:00.000Z", modifier: "", dataType: "Over Time Registration", employee: ""},
    { id: 5, name: "Duyệt ĐK tăng ca - Production", code: 'OT_AI05', modifyDate: "2021-12-27T00:00:00.000Z", modifier: "", dataType: "Over Time Registration", employee: ""},
    { id: 6, name: "Duyệt ĐK tăng ca - Production", code: 'OT_AI05', modifyDate: "2021-12-27T00:00:00.000Z", modifier: "", dataType: "Over Time Registration", employee: ""},
    { id: 7, name: "Duyệt ĐK tăng ca - Production", code: 'OT_AI05', modifyDate: "2021-12-27T00:00:00.000Z", modifier: "", dataType: "Over Time Registration", employee: ""},
    { id: 8, name: "Duyệt ĐK tăng ca - Production", code: 'OT_AI05', modifyDate: "2021-12-27T00:00:00.000Z", modifier: "", dataType: "Over Time Registration", employee: ""},
    { id: 9, name: "Duyệt ĐK tăng ca - Production", code: 'OT_AI05', modifyDate: "2021-12-27T00:00:00.000Z", modifier: "", dataType: "Over Time Registration", employee: ""},
    { id: 10, name: "Duyệt ĐK tăng ca - Production", code: 'OT_AI05', modifyDate: "2021-12-27T00:00:00.000Z", modifier: "", dataType: "Over Time Registration", employee: ""},
    { id: 11, name: "Duyệt ĐK tăng ca - Production", code: 'OT_AI05', modifyDate: "2021-12-27T00:00:00.000Z", modifier: "", dataType: "Over Time Registration", employee: ""},
  ];


  const cellEditRender = (data) => {
    return (
      <Link to={`/approval-setting/${data.data.id}`} className="dx-edit-link-datagrid">
        <img src='/assets/images/icon-edit.svg' alt="edit-row" className="dx-icon-link-datagrid" />
      </Link>
    );
  }

  const onOpenRightSidePanel = (e) => {
    setOpenedSide(true);
  }
  const onCloseRightSidePanel = (e) => {
    setOpenedSide(false);
  }

  return (
    <React.Fragment>
      <Button
        text="Open Right Sidebar"
        type="normal"
        stylingMode="contained"
        onClick={onOpenRightSidePanel}
      />
      <div className={`right-side-panel ${openedSide ? 'open' : null}`}>
        <div className={'section'}>
          <div className={'section-heading has-page-title'}>
            <h4 className={'page-title'}>Approval level</h4>
            <div className={`page-actions`}>
              <Toolbar>
                <Item 
                  location="after"
                  locateInMenu={isXSmall ? 'always' : 'auto'}
                >
                  <Button 
                    text="Cancel"
                    className="mr-1"
                    onClick={onCloseRightSidePanel}/>
                  <Button 
                    text="OK" 
                    type="default"
                    onClick={onCloseRightSidePanel}/>
                </Item>
              </Toolbar>
            </div>
          </div>
          <div className={'section-body'}>
              <table className="data-readonly">
                <tbody>
                  <tr>
                    <td>Manager: <span className="required">*</span></td>
                    <td>Quality Control; 600098; Lê Anh Tô; Worker Skill B</td>
                  </tr>
                  <tr>
                    <td>Sub Manager: <span className="required">*</span></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>Level: <span className="required">*</span></td>
                    <td>0</td>
                  </tr>
                </tbody>
              </table>

              <Toolbar className="mt-1 mb-1">
                <Item 
                  location="before"
                  locateInMenu={'never'}
                >
                  <h4 className={'section-subtitle mb-0'}>Approval Settings</h4>
                </Item>
                <Item 
                  location="after"
                  locateInMenu={isXSmall ? 'always' : 'auto'}
                  cssClass={"datagrid-toolbar-actions-dropdown"}
                >
                  <Button 
                    icon="revert"
                    text="Reset View Setting"
                    className="mr-1" />
                  <Button 
                    icon={`<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.6667 8.66667V12C12.6667 12.3667 12.3667 12.6667 12 12.6667H4C3.63333 12.6667 3.33333 12.3667 3.33333 12V8.66667C3.33333 8.3 3.03333 8 2.66667 8C2.3 8 2 8.3 2 8.66667V12.6667C2 13.4 2.6 14 3.33333 14H12.6667C13.4 14 14 13.4 14 12.6667V8.66667C14 8.3 13.7 8 13.3333 8C12.9667 8 12.6667 8.3 12.6667 8.66667ZM8.66667 8.44667L9.92 7.19333C10.18 6.93333 10.6 6.93333 10.86 7.19333C11.12 7.45333 11.12 7.87333 10.86 8.13333L8.46667 10.5267C8.20667 10.7867 7.78667 10.7867 7.52667 10.5267L5.13333 8.13333C4.87333 7.87333 4.87333 7.45333 5.13333 7.19333C5.39333 6.93333 5.81333 6.93333 6.07333 7.19333L7.33333 8.44667V2.66667C7.33333 2.3 7.63333 2 8 2C8.36667 2 8.66667 2.3 8.66667 2.66667V8.44667Z" fill="#384455"/></svg>`}
                    text="Export"
                  />
                </Item>
              </Toolbar>
              <DataGrid
                showBorders={true}
                showRowLines={true}
                hoverStateEnabled={true}
                rowAlternationEnabled={true}
                columnAutoWidth={true}
                columnHidingEnabled={true}
                alignment="center"
                dataSource={dataTable}
                className="datagrid-has-toolbar-actions"
              >
                <Selection
                  mode="multiple"
                  selectAllMode="page"
                  showCheckBoxesMode="always"
                />
                <FilterRow visible={true} />
                <Paging defaultPageSize={10} />
                <Pager
                  showPageSizeSelector={true}
                  allowedPageSizes={[10, 20, 50, 100]}
                  showInfo={true}
                />
                <Column
                  width={60}
                  alignment="center"
                  allowSearch={false}
                  cellRender={cellEditRender}
                />
                <Column
                  caption="Name"
                  dataField="name"
                  dataType="string"
                  allowSearch={true}
                />
                <Column
                  caption="Code"
                  dataField="code"
                  dataType="string"
                  hidingPriority={isXSmall ? 1 : false}
                  width={160}
                />
                <Column
                  caption="Modify Date"
                  dataField="modifyDate"
                  dataType="date"
                  format="dd.MM.yyyy"
                  hidingPriority={isXSmall ? 2 : false}
                  width={120}
                />
                <Column
                  caption="Modifier"
                  dataField="time"
                  dataType="string"
                  hidingPriority={isXSmall ? 3 : false}
                  width={120}
                />
                <Column
                  caption="Data Type"
                  dataField="dataType"
                  dataType="string"
                  width={120}
                  hidingPriority={isXSmall ? 4 : false}
                />
                <Column
                  caption="Employee"
                  dataField="employee"
                  dataType="string"
                  hidingPriority={isXSmall ? 5 : false}
                  width={120}
                />
              </DataGrid>
          </div>
        </div>
      </div>
      {
        openedSide && <div className="right-side-panel-backdrop" onClick={onCloseRightSidePanel} />
      }
    </React.Fragment>
)}
